import { 
    FETCH_APP_SELECT_OPTIONS_PENDING,
    FETCH_APP_SELECT_OPTIONS_SUCCESS,
    FETCH_APP_SELECT_OPTIONS_ERROR
} from "../../constants/actionTypes";

const initialState = {
    error: null,
    pending: false,
    selectOptions: {},
};

const selectOptionsReducer = (state = initialState, action) => {
    switch(action.type) {
        case FETCH_APP_SELECT_OPTIONS_PENDING:
            return {
                ...state,
                pending: true
            };
        case FETCH_APP_SELECT_OPTIONS_SUCCESS:
            return {
                ...state,
                selectOptions: action.payload,
            };
        case FETCH_APP_SELECT_OPTIONS_ERROR:
            return {
                ...state,
                pending: false,
                error: action.error,
            };
        default:
            return state;
    }
};

export default selectOptionsReducer;